import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BrainCircuit, Building2, ShieldCheck } from 'lucide-react';
export function FramingBand() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="bg-surface-muted py-20 border-y border-line" data-id="element-637">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-638">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-4xl mx-auto mb-16" data-id="element-639">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-ink-dark leading-tight text-balance" data-id="element-640">
            A New Infrastructure for Human Capability, Civic Development, and
            Leadership Readiness
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16" data-id="element-641">
          {/* Column 1 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center text-center" data-id="element-642">
            <div className="w-14 h-14 rounded-full bg-white shadow-sm border border-line flex items-center justify-center mb-6 text-navy" data-id="element-643">
              <BrainCircuit size={28} strokeWidth={1.5} data-id="element-644" />
            </div>
            <h3 className="text-xl font-heading font-bold text-ink-dark mb-3" data-id="element-645">
              Human Capability Development
            </h3>
            <p className="text-ink-muted leading-relaxed" data-id="element-646">
              Build stronger reasoning, regulation, and self-direction from
              early development through adulthood.
            </p>
          </motion.div>

          {/* Column 2 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center text-center" data-id="element-647">
            <div className="w-14 h-14 rounded-full bg-white shadow-sm border border-line flex items-center justify-center mb-6 text-teal" data-id="element-648">
              <Building2 size={28} strokeWidth={1.5} data-id="element-649" />
            </div>
            <h3 className="text-xl font-heading font-bold text-ink-dark mb-3" data-id="element-650">
              Institutional Readiness
            </h3>
            <p className="text-ink-muted leading-relaxed" data-id="element-651">
              Support schools, employers, civil society, and public systems with
              actionable capability metrics.
            </p>
          </motion.div>

          {/* Column 3 */}
          <motion.div variants={itemVariants} className="flex flex-col items-center text-center" data-id="element-652">
            <div className="w-14 h-14 rounded-full bg-white shadow-sm border border-line flex items-center justify-center mb-6 text-navy-light" data-id="element-653">
              <ShieldCheck size={28} strokeWidth={1.5} data-id="element-654" />
            </div>
            <h3 className="text-xl font-heading font-bold text-ink-dark mb-3" data-id="element-655">
              Leadership Qualification
            </h3>
            <p className="text-ink-muted leading-relaxed" data-id="element-656">
              Strengthen readiness for high-responsibility roles, crisis
              management, and governance stability.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}